import type { RootState } from "@/app/store";
import { LaboratorioAnalise } from "@/contexts/laboratorio/laboratorioAnalise/model/LaboratorioAnalise";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LaboratorioState {
  items: LaboratorioAnalise[];
  synced: boolean;
}

const initialState: LaboratorioState = {
  items: [],
  synced: false,
};

const laboratorioSlice = createSlice({
  name: "LABORATORIO",
  initialState,
  reducers: {
    sync: {
      reducer: (
        state,
        action: PayloadAction<{ items: LaboratorioAnalise[] }>
      ) => {
        state.items = action.payload.items;
        state.synced = true;
      },
      prepare: (items: LaboratorioAnalise[]) => ({
        payload: { items },
      }),
    },
  },
});

export const laboratorioAction = laboratorioSlice.actions;

export default laboratorioSlice.reducer;

export const getLaboratorioSynced = (state: RootState) =>
  state.laboratorio.items;
